export default __webpack_public_path__ + "static/media/brand_logo_light.0c0226f3.svg";